import { getApiSubscriptionCurrent } from '@/shared/apis/fastmile/generated/subscription/subscription'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchSubscription = createAsyncThunk('subscription/fetchSubscription', async (_, { rejectWithValue }) => {
  try {
    const response = await getApiSubscriptionCurrent()

    return response.data
  } catch (error) {
    return rejectWithValue('Failed to fetch subscription')
  }
})
